import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { CargoItemInterface, CargoListResponse } from '../../common/types/interfaces'

const initialState: { data: CargoListResponse } = {
  data: {
    data: [],
    total: 0,
  },
}

export const cargoListSlice = createSlice({
  name: 'slot-list',
  initialState,
  reducers: {
    setCargoList: (state, action: PayloadAction<CargoListResponse>) => {
      state.data = { ...action.payload }
    },
    replaceCargoById: (state, action: PayloadAction<CargoItemInterface>) => {
      state.data = {
        ...state.data,
        data: [...state.data.data.filter((el) => el.id !== action.payload.id)],
      }
      state.data = { ...state.data, data: [...state.data.data, action.payload] }
    },
    removeCargoById: (state, action: PayloadAction<number>) => {
      state.data = {
        ...state.data,
        data: [...state.data.data.filter((el) => el.id !== action.payload)],
      }
    },
  },
})

export const { setCargoList } = cargoListSlice.actions
export const { replaceCargoById } = cargoListSlice.actions
export const { removeCargoById } = cargoListSlice.actions

export const selectCargoList = (state: RootState) => state.cargoList.data
export const selectCargoItem = (state: RootState, id: number) =>
  state.cargoList.data.data.find((el) => el.id === id)

export default cargoListSlice.reducer
